// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__MhOaX","disabled":"Checkbox_disabled__2eJBY"};